import { render, staticRenderFns } from "./SimpleSignup.vue?vue&type=template&id=7365f77e&scoped=true&"
import script from "./SimpleSignup.vue?vue&type=script&setup=true&lang=js&"
export * from "./SimpleSignup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7365f77e",
  null
  
)

export default component.exports